export default __webpack_public_path__ + "static/media/logo-text.6e29ce02.svg";